import * as React from "react";

const SvgTriangle = props => <svg width={4} height={8} viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M0 4L4 0L4 8L0 4Z" fill="white" /></svg>;

export default SvgTriangle;